import { Observable } from 'rxjs';
import Axios from 'axios-observable';

const Domain = process.env.REACT_APP_MAIN_API_SERVER;

class TaxonomyMaps {
    get() {
        return new Observable(subscriber => {
            Axios.get(Domain + '/taxonomy/available-models/').subscribe(resp => {
                subscriber.next(resp.data.data);
                subscriber.complete();
            });
        })
    }
}
export default new TaxonomyMaps();